import React from 'react';
import '../css/StudentSuccessSectors.css';

const StudentSuccessSectors = () => {
  const sectors = [
    "Construction Industry",
    "Oil & Gas Sector",
    "Manufacturing Companies",
    "Infrastructure Projects",
    "Facility Management"
  ];

  return (
    <section className="gfi-success-sectors-section">
      <div className="gfi-success-sectors-container">
        
        <div className="gfi-success-sectors-mesh-grid">
          
          {/* LEFT COLUMN: TYPOGRAPHY HEADINGS & HIGHLIGHT BANNER BOX */}
          <div className="gfi-ss-left-column">
            <h2 className="gfi-ss-main-heading">Success of <br />Our Students</h2>
            <p className="gfi-ss-sub-caption">
              Many of our students are working in top industrial sectors worldwide.
            </p>

            {/* Left Accent Bar Blue Focus Box Card */}
            <div className="gfi-ss-ventures-highlight-card">
              <p className="gfi-ss-highlight-statement-txt">
                Some of our pass-out students have also started their own Fire & Safety training institutes and professional ventures.
              </p>
            </div>
          </div>

          {/* RIGHT COLUMN: KEY WORKING SECTORS MASSIVE BACKDROP EMBED */}
          <div className="gfi-ss-right-column">
            <div className="gfi-ss-sectors-panel-card">
              
              <h3 className="gfi-ss-panel-inside-title">Key Working Sectors:</h3>
              
              {/* 2-Column Sector Pills Grid Wrapper */}
              <div className="gfi-ss-sectors-flex-mesh">
                {sectors.map((sector, index) => (
                  <div key={index} className="gfi-ss-sector-item-pill">
                    <span className="gfi-ss-sector-arrow-pointer">→</span>
                    <span className="gfi-ss-sector-label-txt">{sector}</span>
                  </div>
                ))}
              </div>

            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default StudentSuccessSectors;